import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { resetPassword } from "../slice/workerAuthSlice";
import WorekrHeader from "../../worker-header/components/index";
import WorkerFooter from "../../worker-footer/components/index";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ResetPassword = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.workerAuth);

    const [searchParams] = useSearchParams();

    const token = searchParams.get("token");
    const emailFromUrl = searchParams.get("email");

    const [email] = useState(emailFromUrl || "");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            toast.error("Passwords do not match");
            return;
        }

        const payload = {
            token: token,
            email: email,
            password: password,
            password_confirmation: confirmPassword,
        };

        const result = await dispatch(resetPassword(payload));

        if (result.meta.requestStatus === "fulfilled") {
            toast.success(result.payload?.message || "Password reset successful");
            setPassword("");
            setConfirmPassword("");
            navigate("/signin");
        } else {
            toast.error(result.payload?.message || "Reset failed");
        }
    };

    return (
        <>
            <WorekrHeader />
            <main className="overflow-hidden">
                <section className="container mt-5">
                    <div className="row justify-content-center">
                        <div className="col-md-6 col-lg-4">
                            <h3 className="text-center mb-4">Reset Password</h3>

                            <form onSubmit={handleSubmit}>

                                <input
                                    type="email"
                                    className="form-control mb-3"
                                    value={email}
                                    disabled
                                />

                                <input
                                    type="password"
                                    className="form-control mb-3"
                                    placeholder="New Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />

                                <input
                                    type="password"
                                    className="form-control mb-3"
                                    placeholder="Confirm Password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />

                                <button className="btn btn-primary mb-4" disabled={loading}>
                                    {loading ? "Please wait..." : "Reset Password"}
                                </button>

                            </form>
                        </div>
                    </div>
                </section>
                <WorkerFooter />
            </main>
        </>
    );
};

export default ResetPassword;